<template>
  <div id="register-setting-page">
    <div class="page-name">
      <div class="page-title">News</div>
    </div>
    <div class="page-container">
      <b-card class="w-100">
        <new-table
          :data="news"
          :paginate="paginate"
          :onSetActive="onSetActive"
          :onUpdatePaginate="onUpdatePaginate"
          :onUpdateLimit="onUpdateLimit"
          :onUpdateSort="onUpdateSort"
          :onDeleteNews="onDeleteNews"
        />
      </b-card>
      <br />
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
import { mapActions } from 'vuex'
import { ActionFetch } from '@/store/actionTypes'
import NewsTable from '@/components/tables/NewsTable'

export default {
  components: {
    'new-table': NewsTable,
  },
  data: () => ({
    enable: true,
    news: [],
    paginate: {
      limit: 10,
      page: 1,
      totalPage: 1,
      totalRow: 0,
    },
  }),
  methods: {
    ...mapActions({
      getNewsList: ActionFetch.PROJECT_NEWS.LIST,
      updateNews: ActionFetch.PROJECT_NEWS.UPDATE,
      updateSort: ActionFetch.PROJECT_NEWS.UPDATESORT,
      deleteData: ActionFetch.PROJECT_NEWS.DELETE,
    }),
    onDeleteNews($id) {
      this.deleteData($id).then(($res) => {
        if ($res.success) {
          this.fetchNews()
        }
      })
    },
    onSetActive($data, $news) {
      $news.status = $data.value ? 'Active' : 'Inactive'

      let newsSave = {
        id: $news.id,
        status: $news.status,
      }

      this.updateNews(newsSave)
    },
    onUpdatePaginate($paginate) {
      this.paginate.page = $paginate

      this.fetchNews()
    },
    onUpdateSort($data) {
      this.updateSort($data).then(($res) => {
        if ($res.success) {
          this.fetchNews(this.paginate.page)
        }
      })
    },
    onUpdateLimit($limit) {
      this.paginate.limit = $limit
      this.paginate.page = 1

      this.fetchNews()
    },
    renderDate(date) {
      return format(date, 'YYYY-MM-DD')
    },
    async fetchNews() {
      let data = {
        orderBy: 'orderNum',
        direction: 'asc',
        limit: this.paginate.limit,
        page: this.paginate.page,
      }
      this.getNewsList(data).then(($res) => {
        if ($res.success) {
          this.news = $res.data.map(($data) => {
            if ($data.endDate) {
              const endDate = new Date($data.endDate)
              let dd = endDate.getDate()
              let mm = endDate.getMonth() + 1
              let yy = endDate.getFullYear()
              const currentEndDate = new Date(`${yy}-${mm}-${dd} 23:59:59`)
              const currentDate = new Date()

              if (currentEndDate < currentDate) {
                $data.status = 'Inactive'
              }
            }

            return $data
          })
          this.paginate.totalPage = $res.dataLimit
            ? $res.dataLimit.totalPage
            : 1
          this.paginate.totalRow = $res.dataLimit ? $res.dataLimit.totalData : 0
        }
      })
    },
  },
  created() {
    this.fetchNews()
  },
}
</script>

<style>
td {
  vertical-align: middle !important;
  font-size: 14px;
}
</style>
